"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.functionToStringIntegration = void 0;

var _currentScopes = require("../currentScopes.js");

var _integration = require("../integration.js");

var _object = require("../utils-hoist/object.js");

let originalFunctionToString;
const INTEGRATION_NAME = 'FunctionToString';
const SETUP_CLIENTS = new WeakMap();

const _functionToStringIntegration = () => {
  return {
    name: INTEGRATION_NAME,

    setupOnce() {
      // eslint-disable-next-line @typescript-eslint/unbound-method
      originalFunctionToString = Function.prototype.toString; // intrinsics (like Function.prototype) might be immutable in some environments
      // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)

      try {
        Function.prototype.toString = function (...args) {
          const originalFunction = (0, _object.getOriginalFunction)(this);
          const context = SETUP_CLIENTS.has((0, _currentScopes.getClient)()) && originalFunction !== undefined ? originalFunction : this;
          return originalFunctionToString.apply(context, args);
        };
      } catch (e) {// ignore errors here, just don't patch this
      }
    },

    setup(client) {
      SETUP_CLIENTS.set(client, true);
    }

  };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */


const functionToStringIntegration = exports.functionToStringIntegration = (0, _integration.defineIntegration)(_functionToStringIntegration);